import { useEffect, useRef, useState } from "react";

const useSticky = (initialOffset = 0) => {
    const stickyRef = useRef<HTMLDivElement>(null);
    const [sticky, setSticky] = useState(false);
    const [offset, setOffset] = useState(initialOffset);

    useEffect(() => {
        if (!stickyRef.current) {
            return;
        }
        setOffset(stickyRef.current.offsetTop);
    }, [stickyRef, setOffset]);

    useEffect(() => {
        const handleScroll = () => {
            if (!stickyRef.current) {
                return;
            }

            const condition =
                window.scrollY > offset + 150 ||
                (sticky &&
                    window.scrollY > offset &&
                    window.scrollY <= offset + 150);

            setSticky(condition);
        };
        window.addEventListener("scroll", handleScroll);
        return () => window.removeEventListener("scroll", handleScroll);
    }, [setSticky, stickyRef, offset]);
    return { stickyRef, sticky, setOffset };
};

export default useSticky;
